var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircledOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5195_16238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.676758C9.71591 0.676758 12.3232 3.28409 12.3232 6.5C12.3232 9.71591 9.71591 12.3232 6.5 12.3232C3.28409 12.3232 0.676758 9.71591 0.676758 6.5C0.676758 3.28409 3.28409 0.676758 6.5 0.676758ZM6.5 1.48926C3.73282 1.48926 1.48926 3.73282 1.48926 6.5C1.48926 9.26718 3.73282 11.5107 6.5 11.5107C9.26718 11.5107 11.5107 9.26718 11.5107 6.5C11.5107 3.73282 9.26718 1.48926 6.5 1.48926ZM6.5 5.82324C6.72437 5.82324 6.90625 6.00513 6.90625 6.22949V8.9375C6.90625 9.16187 6.72437 9.34375 6.5 9.34375C6.27563 9.34375 6.09375 9.16187 6.09375 8.9375V6.22949C6.09375 6.00513 6.27563 5.82324 6.5 5.82324ZM6.20312 3.79004C6.35322 3.62327 6.61057 3.60967 6.77734 3.75977C6.94409 3.90986 6.9577 4.16722 6.80762 4.33398L6.80176 4.33984C6.65173 4.5063 6.39522 4.51986 6.22852 4.37012C6.06175 4.22002 6.04815 3.96267 6.19824 3.7959L6.20312 3.79004Z",
    fill: "#4B8D6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5195_16238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircledOutline);
export default __webpack_public_path__ + "static/media/infoCircledOutline.f32c85650259298d8692b7eebb06f774.svg";
export { ForwardRef as ReactComponent };